export const UIConstants = {
    Global_Roles:'Global_Roles',
    Role: 'Role',
    Group: 'Business Group',
    Platform: 'Platform',
    Form: 'Form',
    AccountType: 'Account Type',
    PermissionType: 'Permission Type',
    PermissionGroup: 'Permission Group',
    PermissionScope: 'Permission Scope',
    PermissionLevel: 'Permission Level',
    Attributes: 'Attribute',
    BusinessJustfication: 'Business Justification',
    Reason: 'Reason',
    BusinessOwner: 'Business Owner',
    Signature: 'Signature',
    AlternateManager:'Alternate Manager',
    TermsAndConditions: 'Terms & Conditions',
    Subsidaries: 'Subsidaries',
    SubsidiarySelection: 'Subsidiary Selection',
    BusinessSelection: 'Business Selection',
    Users: 'User Data',
    DefaultReportingSubsidiary: 'Default Reporting Subsidiary',
    File: 'File',
    FileType: 'File type is not supported. CSV file',
    FiscalCycles: 'Fiscal cycles',
    UserEmail: 'UserEmail',
    Select: 'Select',
    RequestPreview: 'Access Request Preview',
    Messages: {
        ManagerNotFound: "The unavailability of your manager's information prevents you from submitting this request. A manager is required for request approval.",
        UserAliasChange: "Your user alias has been updated in Azure Active Directory. Please contact the EUA support team to proceed further.",
        TenantConfigurationNotFound: 'Tenant Configuration is missing',
        ResetConfirmation: 'Are you sure you want to reset the changes?',
        SaveConfirmation: 'Are you sure you want to submit this request?',
        RevokeConfirmation: 'Are you sure you want to revoke your access?',
        BulkRemovalConfirmation: "You are revoking access for '#count#' User(s). Are you sure you want to proceed?",
        RemoveRoleConfirmation: "Are you sure you want to remove '#RoleName#' ?",
        BasicRoleRemovalNote: "Removal of BASIC access will also remove INFORMA access.",
        AdvanceRoleRemovalNote: "Removal of Advanced access will also remove BASIC and INFORMA access.",
        PLPlanRemovalNote :'Removal of P&L role access will also remove INFORMA access.',
        RemoveRoleConfirmationAdmin: "Are you sure you want to remove '#RoleName#' for '#UserAlias#' ?",
        RemoveReviewConfirmationAdmin: "Are you sure you want to cancel '#ReviewName#' ?",
        InviteConfirmation: 'Are you sure you want to send email invite to selected User(s)?',
        SaveSuccess: 'Request submitted successfully.',
        SaveSuccessForDifferentPL: 'Request submitted successfully. Once your new P&L role is approved, your existing role will be removed.',
        SaveSuccessForDifferentTrail: 'Request submitted successfully. Once your new Trial balance role is approved, your existing role will be removed.',
        BulkRemovalSuccess: 'Bulk removal successfully processed.',
        ReviewSaveSuccess: 'Review submitted successfully.',
        RemoveSuccess: 'Access removed successfully.',  
        RemoveFailure: 'Failed to remove your request.',
        CancelReviewSuccess: 'Review cancelled successfully.',
        CancelReviewFailure: 'Failed to cancel your review.',
        InviteSuccess: 'Email invite sent successfully!',
        EndpointNotFound: 'Endpoint not found.',
        SaveFailure: 'Failed to submit your request.',
        FetchFailure: 'An unexpected error occurred.',
        RequestStatusNotFound: 'Request not found.',
        ScopeRemovalRequest: 'This is a scope removal request',
        InvalidProcessingError: 'There was an error processing your request. Please contact euaengineering@microsoft.com for further assistance.',
        RoleNotConfigured: 'No Role has been configured.',
        JustificationMaxLength: 'Business justification should not exceed 500 characters.',
        InvalidReason: 'Comments are Mandatory',
        ReviewNameMaxLength: 'Review Name should not exceed 200 characters.',
        MandatoryField: 'Please fill in all required field.',
        HasExistingAccess: 'You already have access for ',
        ScopesRequired: 'required.',
        SubmitInProgress: 'Please wait while we process your Request.',
        InviteInProgress: 'Please wait while we send invitation your Request.',
        SubmitInProgressTitle: 'Processing...',
        RemoveRequestConfirmation: "Are you sure you want to remove your access request - '#Request#'?",
        LoadingDescription: 'Please wait while loading the page',
        Loading: 'Loading...',
        preventedRoutetoCEO: 'Warning: Access request cannot be routed to CEO. Please choose an alternate FTE approver.',
        MDSScopesRequired: 'Scope ',
        RoleRemovalSuccess: 'Role removed successfully.',
        UserAdditionSuccess: 'User added to the role successfully.',
        AttestationExpiredReason: 'Since no action was taken after reminder emails from euaeng@microsoft.com, your #TenantName# account has been removed for non-compliance. If you require access, please submit a new request through the Access Request page.',
    },
  MessageBoxTitle: {
    Success: 'Success',
    Reset: 'Reset',
    RemoveAccess: 'Remove Access',
    RemoveRole: 'Remove Role',
    Error: 'Error',
    SaveAccess: 'Submit Access',
    BulkRemoval: 'Bulk Removal',
    InviteUser: 'Invite Users',
    MyAccess: 'My Access',
    MyAccessEdit: 'My Access (View/Edit)',
    AccessDetails: 'Access Details',
    AccessHistory: 'Access History',
    AssetDetails: 'Asset Details',
    ReviewDetails: 'Review Details',
    UserDetails: 'User Details',
    RegistrationDetails: 'Registration Details',
    CancelReview: 'Cancel Review',
    Permissions: 'Permissions',
    CreatePermissions: 'Create Permissions',
    RemovePermissions: 'Remove Permissions',
  },
    ButtonText: {
        Close: 'Close',
        Ok: 'OK',
        Cancel: 'Cancel',
        Dismiss: 'Dismiss',
        Reset: 'Reset',
        Save: 'Save',
        Submit: 'Submit',
        SendInvite: 'Send Invite',
        Edit: 'Edit',
        Renew: 'Renew',
        Add: 'Add',
        Delete: 'Delete',
        Yes: 'Yes',
        No: 'No',
        ViewMyCurrentAccess: 'View/Edit My Access',
        ManageAcces: 'Manage Access',
        RemoveAccess: 'Remove Access',
        EditAccess: 'Edit Access',
        Remove: 'Remove',
        Search: 'Search',
        Update: 'Update',
        CreateReview: 'Create Review',
        FAQs: 'FAQs'
    },
    PageTitle: {
        Permissions:'Permissions',
        AccessRequest : 'Access Request',
        MyRequestHistory : 'My Request History',
        InviteUser : 'Invite Users',
        AppTitle : 'Enterprise User Access',
        Administration: 'Administration',
        Reports: 'Reports',
        UserManagement: 'User Management',
        BulkRemoval: 'Bulk Removal',
        BulkRemove: 'Bulk Remove',
        UpdateRequest: 'Update Request',
        EditRequest: 'Edit Request',
        AssetView: 'Asset View',
        RegistrationRequestView: 'Registration Request View',
        ConsumerAccessRequestView: 'Consumer Access Request',
        ConsumerAssetMappingView: 'Consumer Asset Mapping',
        AccessReviewManagement: 'Access Review',
        CreateReview: 'Create Review',
        MercuryDRSForm: 'DRS',
        DRSAccessRequest: 'DRS Access Request',
        MyPendingApprovals: 'My Pending Approvals',
        ApprovalPolicy: 'Approval Policy',
        AttributeManagement: 'Attribute Management',
        RoleManagement: 'Role Management',
        FAQs: 'FAQs',
        TrainingLinks: 'Training Links',
        HierarchyUpdates: 'Hierarchy Management',
        AuthDefinitions: 'Auth Definitions',
        BulkAccessRequest: 'Bulk Access Request',
    },
    Labletext: {
        RequestType: 'Request Type',
        MyApprovedRequest: 'My Approved Requests:',
        MyPendingAccess: 'My Pending Requests:',
        SelectUserOrGroup: 'Select Users / Group',
        Users: 'Users',
        Groups: 'Groups',
        CompanyCode: 'Company Code',
        Country : 'Country',
        RoleType: 'Financial Controller Type',
        SAPSystem : 'SAP System',
        Status : 'Status',
        InitialMigration: 'Initial migration data',
        OnBehalf: 'On Behalf',
        Removed : "Removed",
        Expired: "Expired",
        OperationsDetail: "OperationsDetail",
        AssignUser: "Assign User",
        RequestPreview: 'Access Request Preview',
    },
    Status: {
        Submitted: 'Submitted',
        InProgress: 'InProgress',
        Complete: 'Complete',
        Approved: 'Approved',
        Rejected: 'Rejected'
    },
    PlaceHolderText: {
        SearchService: 'Search for a service',
        SearchAttribute: 'Search for '
    },
    RequestType: {
        Add: 'Add',
        Remove: 'Remove',
        Update: 'Update',
        BulkRemove: 'Bulk Remove',
        AttestationExpired: 'Attestation Expired'
    },
    Configuration: {
        JEMTenantId: 'JEMTenantId',
        SAPRequestStatusEndPoint: 'SAPRequestStatusEndPoint',
        FDABotHostURL: 'FDABotHostURL',
        TenantConfig: 'TenantConfig',
        FDABotHostID: 'FDABotHostAppId',
        EnvironmentConfig: 'EnvironmentConfig',
        RolesForTenantConfig:'RolesForTenantConfig',
        KarnakGroupConfig: 'GroupConfig',
        MSTRoleGroupConfig: 'MSTRoleGroupConfig',
        MSSalesSubsidiaries: 'MSSalesSubsidiaries',
        FlightConfig: 'FlightConfig',
        VLAppsConfig: 'VLAppsConfig',
        PartnerCenterConfig: 'PartnerCenterConfig',
        KarnakFunctionConfig: 'KarnakFunctionConfig',
        MSSalesConfig: 'MSSalesConfig',
        MSApprovalLink: 'MSApprovalLink',
        DisplayAccessReview: 'DisplayAccessReview',
        MercuryConfig: 'MercuryConfig',
        MercuryV3Config: 'MercuryV3Config',
        MercuryFAQConfig: 'MercuryFAQConfig',
        AllowedAccountTypes: 'AllowedAccountTypes',
        QuizValidation: 'QuizValidation',
        FeatureFlags: 'FeatureFlags',
        EuaEngGroupId: 'EuaEngGroupId',
        AccessExpiryReminderWindowDays: 'AccessExpiryReminderWindowDays'
    },
    RouteConfig: {
        Permissions:'Permissions',
        RequestRoot : 'request',
        MyAccessRequest : 'myrequest',
        RequestAccess : 'access',
        InviteUser : 'inviteusers',
        UpdateRequest: 'update',
        EditRequest: 'edit',
        Administration: 'administration',
        Reports : 'reports',
        UserManagement: 'usermanagement',
        BulkRemoval: 'bulkremoval',
        BulkRemoveSelfServe: 'bulkremove',
        AssetView : 'assetview',
        RegistrationRequestView: 'registrationrequestview',
        ConsumerAccessRequestView: 'consumeraccessrequestview',
        ConsumerAssetMappingView: 'consumerassetmappingview',
        MSApprovals: 'msapprovals',
        Review: 'review',
        CreateReview: 'createreview',
        DRSForm: 'drsform',
        ApprovalPolicy: 'approvalpolicy',
        AttributeManagement: 'attributemanagement',
        RoleManagement: 'rolemanagement',
        HierarchyUpdates: 'hierarchyupdates',
        MercuryFAQ: 'FAQ',
        AuthDefinitions: 'authdefinitions',
        BulkAccessRequest: 'bulkaccess',
    },
    RoleDefinition: {
        Company_Allow_1: 'Company_Allow_1',
        Policy: 'Policy',
        Company: 'Company',
        UIDisplayFlag : 'UIDisplayFlag:false',
        AllowEditFlag: 'AllowEdit:true',
        AllowRenewFlag: 'AllowRenew:true',
        AllScopesRequired: 'AllScopesRequired:false',
        MSSalesBasicRole: 'User Account - Basic',
        BasicAccess: 'Basic Access'
    },
    Tenant: {
        Alfred:'Alfred',
        FDL : 'FDL',
        Karnak : 'Karnak',
        Invoice: 'Invoice',
        FCW: 'FCW',
        MST: 'MST',
        PartnerCenter: 'PartnerCenter',
        MSSales: 'MSSales',
        Mercury: 'Mercury',
        CST: 'CST',
        CST_Prod: 'CST_Prod',
        CST_Canary: 'CST_Canary',
        CMAT: 'CMAT',
        MDS: 'MDS',
        PartnerCenter_WOBO: 'PartnerCenter_WOBO',
        CommerceRadar: 'CommerceRadar',
        PartnerProgramStudio: 'PartnerProgramStudio',
        MyOrder: 'MyOrder',
        MercuryV3: 'MercuryV3',
        FinBITS: 'FinBITS'
    },
    Attribute: {
        OperationsDetail: 'OperationsDetail',
        BusinessGroup: 'BusinessGroup',
        Company: 'Company',
        StatutoryReporting : 'Statutory reporting'
    },
    PermissionTypes: {
        MercuryBasicAccess: 'Basic',
        MercuryAdvanced: 'Advanced',
        MercuryInforma : 'Informa'
    },
    PermissionLevels: {
        MercuryBasicAccess: 'Mercury - Basic Access',
        BasicAccess:'Basic Access',
        Geography: 'Geography',
        FunctionalExeOrgSummary: 'Functional / Exec org Summary',
        ConsolidatedGaap: 'Consolidated Gaap',
        Specific: 'Specific',
        All: 'All companies',
        SCOMP: "Specific Companies"
    },

    PermissionGroups: {
        PLPlanGroup: 'P&L and P&L Plan',
        TrialBalanceGroup : 'Trial Balance & Statutory'
    },
    Review: {
        Name: 'Name',
        Description: 'Description',
        Reviewers: 'Reviewers',
        FiscalYear: 'Fiscal Year',
        Quarter: 'Quarter',
        NameErrorMsg: 'Review Name cannot be empty',
        DuplicateNameErrorMsg: 'The Review Name already exist',
        DescriptionErrorMsg: 'Description cannot be empty',
        FiscalQuarterErrorMsg:'Fiscal Year and Quarter cannot be empty',
        DateErrorMsg: 'EndDate cannot be less than StartDate of the review',
        DateDurationErrorMsg: 'The duration of the review should be minimum 3 days.',
        StartDateErrorMsg: 'StartDate cannot be empty',
        EndDateErrorMsg: 'EndDate cannot be empty',
        StartEndDateErrorMsg: 'StartDate and EndDate cannot be empty',
        ApproversErrorMsg: 'Approvers cannot be empty'
    },
    ProgramFamily: {
        Surface: 'Surface'
    }
}


export const MS_PER_DAY = 1000 * 60 * 60 * 24;
export const EXPIRY_WARNING_COLOR = '#a80000';
export const EXPIRY_WARNING_DAYS = 30;

export const isMercuryTenant = (name: string): boolean =>
    name?.toUpperCase().includes(UIConstants.Tenant.Mercury.toUpperCase()) ?? false;

export const isMSSalesTenant = (name: string): boolean =>
    name?.toUpperCase() === UIConstants.Tenant.MSSales.toUpperCase();
